<template>
  <v-container fluid>
    <v-row class="header py-6 px-4" justify="center">
      <v-col class="text-center">
        <span class="text-h5 font-weight-bold pl-16">{{ $t('notice board') }}</span>
      </v-col>
    </v-row>
    <v-row no-gutters class="pt-16 px-16 mx-16">
      <v-col class="d-flex justify-end">
        <v-btn outlined rounded @click="onAddAd">
          <v-icon left>
            mdi-plus
          </v-icon>
          {{ $t("Add an ad") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row no-gutters class="pt-4 px-16 mx-16">
      <v-col xl="2" lg="4" md="4" sm="4" xs="4" class="ad-tab" :class="currentTab === 'pending' ? 'active' : ''" @click="currentTab = 'pending'">
        <span class="text-h6">{{ $t("Awaiting approval") }}</span>
      </v-col>
      <v-col xl="2" lg="4" md="4" sm="4" xs="4" class="ad-tab mx-2" :class="currentTab === 'approved' ? 'active' : ''" @click="currentTab = 'approved'">
        <span class="text-h6">{{ $t("Famous") }}</span>
      </v-col>
    </v-row>
    <v-row no-gutters class="pt-8 px-16 mx-16">
      <v-col class="header-bar d-flex align-center justify-space-between">
        <v-row no-gutters class="d-flex align-center">
          <v-col cols="auto">
            <v-badge
              color="red"
              overlap
              left
              dot
              offset-x="15"
              offset-y="15"
            >
              <v-btn outlined width="32" height="32" class="square-btn">
                <v-icon left class="mx-0">
                  mdi-bell-outline
                </v-icon>
              </v-btn>
            </v-badge>
          </v-col>

          <v-col cols="auto" class="d-flex align-center mr-16">
            <span class="text-subtitle-2 ml-2">{{ $t("sorting") }}</span>
            <v-icon small color="black">mdi-chevron-down</v-icon>
          </v-col>
        </v-row>
        <v-row no-gutters class="d-flex justify-end">
          <v-col cols="auto">
            <v-text-field
              hide-no-data
              hide-details
              outlined
              dense
              :label='$t("Search")'
            >
              <template v-slot:append>
                <v-icon color="#5D5D5D" dense>mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <donate-list :tab="currentTab" :key="index" @approved="currentTab = 'approved'"></donate-list>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      currentTab: 'pending',
      index: 1,
    }
  },
  methods: {
    onAddAd() {
      this.$router.push({ path: `/banners/add` });
    },
  },
  watch: {
    currentTab() {
      this.index++;
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  background: #F0F0F0;
}
.ad-tab {
  width: 395px;
  height: 64px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-width: 1px;
  border-style: solid;
  border-color: #E6E6E6;
  background-color: #F9F9F9
}
.ad-tab.active {
  border-color: #E9E9E9;
  background-color: #E6E6E6;
}
.header-bar {
  border: 1px solid #E5E5E5;
  padding: 20px !important;
  border-radius: 10px;
  width: 100%;
}
.square-btn {
  padding: 0 !important;
  min-width: auto !important;
  border-color: #E7EAE9 !important;
}
::v-deep .square-btn:hover .v-icon {
  color: #ED220D;
}
::v-deep .v-badge--dot .v-badge__badge{
  height: 4px;
  width: 4px;
}
</style>
